import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { cn } from '@/shared/lib';

type Props = {
  /** Код типа сущности для навигации */
  code: string;
  /** Отображаемое (человекочитаемое) название типа сущности */
  name: string;
  /** Направленная связь (иначе — взаимная) */
  isDirected: boolean;
};

/**
 * Чип связанной сущности в колонке «Связи»: кликабельная ссылка,
 * открывающая страницу этого типа сущности.
 */
export const EntityTypeChip: FC<Props> = ({ code, name, isDirected }) => {
  const navigate = useNavigate();

  return (
    <button
      type="button"
      className={cn(
        'inline-flex items-center rounded-md border bg-background px-2.5 py-0.5 text-xs whitespace-nowrap transition-colors hover:bg-primary-hover',
        isDirected ? 'border-primary text-primary' : 'border-muted-foreground text-muted-foreground',
      )}
      onClick={() => navigate(`/ontology/${code}`)}
    >
      {name}
    </button>
  );
};
